import { render, staticRenderFns } from "./DatasetTabBusinessTerm.vue?vue&type=template&id=66299e4d&scoped=true&lang=pug"
import script from "./DatasetTabBusinessTerm.vue?vue&type=script&lang=js"
export * from "./DatasetTabBusinessTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66299e4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66299e4d')) {
      api.createRecord('66299e4d', component.options)
    } else {
      api.reload('66299e4d', component.options)
    }
    module.hot.accept("./DatasetTabBusinessTerm.vue?vue&type=template&id=66299e4d&scoped=true&lang=pug", function () {
      api.rerender('66299e4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/DatasetTabBusinessTerm.vue"
export default component.exports